<template>
  <div>
    <!-- create update fee -->
    <form @submit.prevent="createUpdateFee">
      <modal
        v-show="isCreateUpdateFeeModalVisible"
        @close="closeFeeModal"
        footer
      >
        <template v-slot:title>
          <h5>{{ fee.id ? "Update" : "Create" }} Fee</h5>
        </template>
        <template v-slot:body>
          <div class="row">
            <div class="form-group">
              <label for="name">Name</label>
              <select name="fee_name" class="form-control" v-model="fee.name">
                <option value="" selected disabled>Please Select A Name</option>
                <option value="Application Fee">Application Fee</option>
                <option value="Penalty Charge">Penalty Charge</option>
                <option value="Other Fees">Other Fee</option>
              </select>
            </div>
            <div class="form-group">
              <label for="amount">Amount (&#8358;)</label>
              <input
                type="text"
                @keyup="formatAmountWithComma"
                v-model="fee.amount"
                class="form-control"
                placeholder="Please Enter Amount Of The Fee"
              />
            </div>
            <div class="form-group">
              <label for="status">Status</label>
              <select name="status" class="form-control" v-model="fee.status">
                <option value="" selected disabled> Select Status</option>
                <option value="active">Active</option>
                <option value="in-active">Inactive</option>
              </select>
            </div>
            <div class=" form-group">
              <label for="description">Description</label>
              <textarea
                v-model="fee.description"
                name="description"
                cols="30"
                rows="5"
                class=" form-control"
                style="resize: none;"
              ></textarea>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <button
            type="submit"
            class="button"
            :disabled="
              fee.id ? null : !feeFormIsValid || createUpdateFeeLoading
            "
          >
            <span class="custom-loader" v-if="createUpdateFeeLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;">
                Please Wait...
              </span>
            </span>
            <span v-else>
              {{ fee.id ? "Update Fee" : "Add Fee" }}
            </span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeFeeModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>

    <!-- create update collateral -->
    <form @submit.prevent="createUpdateCollateral">
      <modal
        v-show="isCreateUpdateCollateralModalVisible"
        @close="closeCollateralModal"
        footer
      >
        <template v-slot:title>
          <h5>{{ collateral.id ? "Update" : "Create" }} Collateral</h5>
        </template>
        <template v-slot:body>
          <div class="row">
            <div class="form-group">
              <label for="name">Name</label>
              <select
                name="collateral_name"
                class="form-control"
                v-model="collateral.name"
              >
                <option value="" selected disabled>Please Select A Name</option>
                <option value="Vehicles">Vehicles</option>
                <option value="Machinery/Equipment">Machinery/Equipment</option>
                <option value="Property">Property</option>
                <option value="Goods/Commodities">Goods/Commodities</option>
                <option value="Financial Instruments"
                  >Financial Instruments</option
                >
              </select>
            </div>
            <div class="form-group">
              <label for="status">Status</label>
              <select
                name="status"
                class="form-control"
                v-model="collateral.status"
              >
                <option value="" selected disabled> Select Status</option>
                <option value="active">Active</option>
                <option value="in-active">Inactive</option>
              </select>
            </div>
            <div class=" form-group">
              <label for="description">Description</label>
              <textarea
                v-model="collateral.description"
                name="description"
                cols="30"
                rows="5"
                class=" form-control"
                style="resize: none;"
              ></textarea>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <button
            type="submit"
            class="button"
            :disabled="
              collateral.id
                ? null
                : !collateralFormIsValid || createUpdateCollateralLoading
            "
          >
            <span class="custom-loader" v-if="createUpdateCollateralLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;">
                Please Wait...
              </span>
            </span>
            <span v-else>
              {{ collateral.id ? "Update Collateral" : "Add Collateral" }}
            </span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeCollateralModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>

    <!-- create custom fields collateral -->
    <form @submit.prevent="createUpdateCustom">
      <modal
        v-show="isCreateUpdateCustomModalVisible"
        @close="closeCustomModal"
        footer
      >
        <template v-slot:title>
          <h5>{{ customField.id ? "Update" : "Create" }} Custom Field</h5>
        </template>
        <template v-slot:body>
          <div class="row">
            <div class="form-group">
              <label for="label">label</label>
              <input
                type="text"
                v-model="customField.label"
                class="form-control"
                placeholder="Please Enter Label Of The Custom Field"
              />
            </div>
            <div class="form-group">
              <label for="status">Status</label>
              <select
                name="status"
                class="form-control"
                v-model="customField.status"
              >
                <option value="" selected disabled> Select Status</option>
                <option value="active">Active</option>
                <option value="in-active">Inactive</option>
              </select>
            </div>
            <div class="form-group">
              <label for="type">Type</label>
              <select
                name="type"
                class="form-control"
                v-model="customField.type"
              >
                <option value="" selected disabled> Select Field Type</option>
                <option value="textarea">Textarea</option>
                <option value="text">Text</option>
                <option value="file">File</option>
                <option value="select">Select</option>
              </select>
            </div>
            <div class="form-group" v-if="customField.type === 'select'">
              <label for="option">Option</label>
              <input
                type="text"
                v-model="customFields.option"
                class="form-control"
              />
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <button
            type="submit"
            class="button"
            :disabled="
              customField.id
                ? null
                : !customFormIsValid || createUpdateCustomLoading
            "
          >
            <span class="custom-loader" v-if="createUpdateCustomLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;">
                Please Wait...
              </span>
            </span>
            <span v-else>
              {{ customField.id ? "Update Custom Field" : "Add Custom Field" }}
            </span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeCustomModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>
    <div
      v-if="getProductDataLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Product details ready...</h3>
        </div>
      </div>
    </div>
    <div class="order--main-content">
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <router-link :to="{ name: 'Services' }" class="arrow_text">
            <chevron-left-icon
              size="1.5x"
              class="custom-class"
              style="vertical-align: top;"
            ></chevron-left-icon>
            <span class="back">Back</span>
          </router-link>
        </div>
      </div>

      <h1 class="mt-2 mb-3 font-regular">
        &nbsp;&nbsp; Product One
      </h1>

      <div class="row mb-5">
        <div class="col-lg-12">
          <ul class="nav nav-tabs nav-overflow header-tabs">
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 1"
                v-bind:class="[activetab === 1 ? 'active' : '']"
              >
                Overview
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 2"
                v-bind:class="[activetab === 2 ? 'active' : '']"
              >
                Fees
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 3"
                v-bind:class="[activetab === 3 ? 'active' : '']"
              >
                Collateral
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 4"
                v-bind:class="[activetab === 4 ? 'active' : '']"
              >
                Custom Fields
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="row" v-if="activetab === 1">
        <div class="col-md-12">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class=" font-weight-600 mb-0">Product Information</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <form @submit.prevent="updateProduct">
                  <div class="row">
                    <div class="form-group">
                      <label for="name">Product Name</label>
                      <input
                        type="text"
                        v-model.trim="productData.name"
                        class="form-control"
                        placeholder="i.e. Berekete,   e.t.c"
                      />
                    </div>
                    <div class="form-group">
                      <label for="description">Description</label>
                      <textarea
                        name="description"
                        v-model="productData.description"
                        id=""
                        cols="30"
                        rows="5"
                        class=" form-control"
                        style="resize: none"
                      ></textarea>
                    </div>

                    <div class="col-6">
                      <div class="form-group">
                        <label for="interest_rate">Interest Rate(%)</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="productData.interest_rate"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label for="interest_rate_type"
                          >Interest Rate Type</label
                        >
                        <select
                          name="interest_rate_type"
                          id=""
                          class="form-control"
                          v-model="productData.interest_rate_type"
                        >
                          <option value="" selected disabled
                            >Select Interest Rate Type</option
                          >
                          <option value="fixed">Fixed</option>
                          <option value="float">Float</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="form-group">
                        <label for="min_amount">Minimum Amount (&#8358;)</label>
                        <input
                          type="text"
                          @keyup="formatMinAmountWithComma"
                          v-model="productData.min_amount"
                          class=" form-control"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label for="max_amount">Maximum Amount (&#8358;)</label>
                        <input
                          type="text"
                          @keyup="formatMaxAmountWithComma"
                          v-model="productData.max_amount"
                          class=" form-control"
                        />
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="margin_finanace">Margin Finance (%)</label>
                      <input
                        type="text"
                        v-model="productData.margin_finance"
                        class=" form-control"
                      />
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label for="min_term">Minimum Term (Months)</label>
                        <input
                          type="text"
                          v-model="productData.min_term"
                          class=" form-control"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label for="max_term">Maximum Term (Months)</label>
                        <input
                          type="text"
                          v-model="productData.max_term"
                          class=" form-control"
                        />
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="penalty">Penalty</label>
                      <select
                        name="penalty"
                        v-model="productData.penalty"
                        class=" form-control"
                      >
                        <option value="" selected disabled
                          >Select Penalty Option</option
                        >
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="button"
                    :disabled="updateLoading"
                  >
                    <span class="custom-loader" v-if="updateLoading">
                      <loader-icon
                        size="1.5x"
                        class="custom-class"
                      ></loader-icon>
                      <span style="font-weight: 600; text-transform: initial"
                        >Updating profile...</span
                      >
                    </span>
                    <span v-else> Save changes </span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Fees -->
      <div class="row" v-if="activetab === 2">
        <div class="col-md-12">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <div class="row align-items-center justify-content-between mb-2">
                <div class="col">
                  <h1 class="mb-2 font-regular">Fees</h1>
                </div>
                <div class="col-auto">
                  <button
                    class="button button--outline text-uppercase"
                    @click="openFeeModal"
                  >
                    Create Fee
                  </button>
                </div>
              </div>
            </div>
            <div class="card-content">
              <div class="card-body">
                <CDataTable
                  :items="fees"
                  :fields="feeFields"
                  :itemsPerPage="small"
                  pagination
                >
                  <template #status="{item}">
                    <td class="table--action-mobile">
                      {{ item.status === "active" ? "Active" : "Inactive" }}
                    </td>
                  </template>
                  <template #actions="{item}">
                    <td class="table--action-mobile">
                      <button class="button" @click="openUpdateFeeModal(item)">
                        Update Fee
                      </button>
                    </td>
                  </template>
                </CDataTable>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- collaterals -->
      <div class="row" v-if="activetab === 3">
        <div class="col-md-12">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <div class="row align-items-center justify-content-between mb-2">
                <div class="col">
                  <h1 class="mb-2 font-regular">Collaterals</h1>
                </div>
                <div class="col-auto">
                  <button
                    class="button button--outline text-uppercase"
                    @click="openCollateralModal"
                  >
                    Create Collateral
                  </button>
                </div>
              </div>
            </div>
            <div class="card-content">
              <div class="card-body">
                <CDataTable
                  :items="collaterals"
                  :fields="collaFields"
                  :itemsPerPage="small"
                  pagination
                >
                  <template #status="{item}">
                    <td class="table--action-mobile">
                      {{ item.status === "active" ? "Active" : "Inactive" }}
                    </td>
                  </template>
                  <template #actions="{item}">
                    <td class="table--action-mobile">
                      <button
                        class="button"
                        @click="openUpdateCollateralModal(item)"
                      >
                        Update
                      </button>
                    </td>
                  </template>
                </CDataTable>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- custom fields -->
      <div class="row" v-if="activetab === 4">
        <div class="col-md-12">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <div class="row align-items-center justify-content-between mb-2">
                <div class="col">
                  <h1 class="mb-2 font-regular">Custom Fields</h1>
                </div>
                <div class="col-auto">
                  <button
                    class="button button--outline text-uppercase"
                    @click="openCustomModal"
                  >
                    Create Custom Fields
                  </button>
                </div>
              </div>
            </div>
            <div class="card-content">
              <div class="card-body">
                <CDataTable
                  :items="customFields"
                  :fields="cFields"
                  :itemsPerPage="small"
                  pagination
                >
                  <template #status="{item}">
                    <td class="table--action-mobile">
                      {{ item.status === "active" ? "Active" : "Inactive" }}
                    </td>
                  </template>
                  <template #actions="{item}">
                    <td class="table--action-mobile">
                      <button
                        class="button"
                        @click="openUpdateCustomModal(item)"
                      >
                        Update
                      </button>
                    </td>
                  </template>
                </CDataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/api.service";
import CDataTable from "@/components/CDataTable.vue";
import CPagination from "@/components/CPagination.vue";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";
import { ChevronLeftIcon } from "vue-feather-icons";
const feeFields = ["name", "amount", "status", "description", "actions"];
const collaFields = ["name", "status", "description", "actions"];
const cFields = ["label", "type", "status", "actions"];
export default {
  name: "ProductComponent",
  props: {
    slug: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    ChevronLeftIcon,
    CDataTable
  },
  data() {
    return {
      feeFields,
      collaFields,
      cFields,
      small: 20,
      getProductDataLoading: false,
      activetab: 1,
      updateLoading: false,
      productData: {},
      isCreateUpdateFeeModalVisible: false,
      fees: [],
      fee: {
        status: "",
        amount: "",
        name: "",
        description: ""
      },
      createUpdateFeeLoading: false,
      collaterals: [],
      collateral: {
        status: "",
        name: "",
        description: ""
      },
      isCreateUpdateCollateralModalVisible: false,
      createUpdateCollateralLoading: false,
      customFields: [],
      customField: {
        status: "",
        type: "",
        option: "",
        label: ""
        // description: ""
      },
      isCreateUpdateCustomModalVisible: false,
      createUpdateCustomLoading: false
    };
  },
  computed: {
    removeCommaFromMinAccount() {
      return this.productData.min_amount.toString().replace(/,/g, "");
    },
    removeCommaFromMaxAccount() {
      return this.productData.max_amount.toString().replace(/,/g, "");
    },
    removeCommaFromAccount() {
      return this.fee.amount.toString().replace(/,/g, "");
    },
    feeFormIsValid() {
      return (
        this.fee.name !== "" &&
        this.fee.amount !== "" &&
        this.fee.status !== "" &&
        this.fee.description !== ""
      );
    },
    collateralFormIsValid() {
      return (
        this.collateral.name !== "" &&
        this.collateral.status !== "" &&
        this.collateral.description !== ""
      );
    },
    customFormIsValid() {
      return (
        this.customField.label !== "" &&
        this.customField.type !== "" &&
        this.customField.status !== ""
      );
    }
  },
  methods: {
    formatMinAmountWithComma() {
      let result = this.productData.min_amount
        .toString()
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.$nextTick(() => (this.productData.min_amount = result));
    },
    formatMaxAmountWithComma() {
      let result = this.productData.max_amount
        .toString()
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.$nextTick(() => (this.productData.max_amount = result));
    },
    formatAmountWithComma() {
      let result = this.fee.amount
        .toString()
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.$nextTick(() => (this.fee.amount = result));
    },
    async getData() {
      this.getProductDataLoading = true;
      try {
        const response = await ApiService.get(
          `backend/loan/product/view-loan-product/${this.slug}`
        );

        this.productData = response.data.data;
        this.getProductDataLoading = false;
      } catch (error) {
        this.getProductDataLoading = false;

        console.log(error.response.data);
      }
    },
    async updateProduct() {
      this.updateLoading = true;
      let newObj = {
        ...this.productData,
        min_amount: parseFloat(this.removeCommaFromMinAccount),
        max_amount: parseFloat(this.removeCommaFromMaxAccount)
      };

      try {
        const response = await ApiService.post(
          `backend/loan/product/update-loan-product/${this.slug}`,
          newObj
        );

        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        setTimeout(() => {
          this.getData();
        }, 3000);
        this.updateLoading = false;
      } catch (error) {
        this.updateLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },

    async openFeeModal() {
      this.isCreateUpdateFeeModalVisible = true;
      this.fee.loan_product_id = this.slug;
    },
    async closeFeeModal() {
      this.isCreateUpdateFeeModalVisible = false;
      this.fee = {};
      this.fee.status = "";
    },
    async openUpdateFeeModal(item) {
      this.fee = Object.assign({}, item);
      this.isCreateUpdateFeeModalVisible = true;
    },
    async createUpdateFee() {
      this.createUpdateFeeLoading = true;
      console.log(this.fee);
      let newObj = {
        ...this.fee,
        amount: parseFloat(this.removeCommaFromAccount)
      };
      try {
        const response = await ApiService.post(
          `backend/loan/product/create-update-fee`,
          newObj
        );

        this.createUpdateFeeLoading = false;

        this.closeFeeModal();
        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        setTimeout(() => {
          this.getFees();
        }, 3000);
      } catch (error) {
        this.createUpdateFeeLoading = false;

        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async getFees() {
      try {
        const response = await ApiService.get(
          `backend/loan/product/fees/${this.slug}`
        );

        this.fees = response.data.data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async getCollaterals() {
      try {
        const response = await ApiService.get(
          `backend/loan/product/collaterals/${this.slug}`
        );

        this.collaterals = response.data.data;
      } catch (error) {
        console.log(error.response.data);
      }
    },
    async openCollateralModal() {
      this.isCreateUpdateCollateralModalVisible = true;
      this.collateral.loan_product_id = this.slug;
    },
    async closeCollateralModal() {
      this.isCreateUpdateCollateralModalVisible = false;
      this.collateral = {};
      this.collateral.status = "";
    },
    async openUpdateCollateralModal(item) {
      this.collateral = Object.assign({}, item);
      this.isCreateUpdateCollateralModalVisible = true;
    },
    async createUpdateCollateral() {
      this.createUpdateCollateralLoading = true;
      console.log(this.collateral);
      try {
        const response = await ApiService.post(
          `backend/loan/product/create-update-collateral`,
          this.collateral
        );

        this.createUpdateCollateralLoading = false;

        this.closeCollateralModal();
        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        setTimeout(() => {
          this.getCollaterals();
        }, 3000);
      } catch (error) {
        this.createUpdateCollateralLoading = false;

        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async getCustoms() {
      try {
        const response = await ApiService.get(
          `backend/loan/product/custom-fields/${this.slug}`
        );

        this.customFields = response.data.data;
      } catch (error) {
        console.log(error.response.data);
      }
    },
    async openCustomModal() {
      this.isCreateUpdateCustomModalVisible = true;
      this.customField.loan_product_id = this.slug;
    },
    async closeCustomModal() {
      this.isCreateUpdateCustomModalVisible = false;
      this.customField = {};
      this.customField.status = "";
      this.customField.type = "";
      this.customField.option = "";
    },
    async openUpdateCustomModal(item) {
      this.customField = Object.assign({}, item);
      this.isCreateUpdateCustomModalVisible = true;
    },
    async createUpdateCustom() {
      this.createUpdateCustomLoading = true;
      console.log(this.customField);
      try {
        const response = await ApiService.post(
          `backend/loan/product/create-update-custom-field`,
          this.customField
        );

        this.createUpdateCustomLoading = false;

        this.closeCustomModal();
        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        setTimeout(() => {
          this.getCustoms();
        }, 3000);
      } catch (error) {
        this.createUpdateCustomLoading = false;

        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    }
  },
  mounted() {
    this.getData();
    this.getFees();
    this.getCollaterals();
    this.getCustoms();
  }
};
</script>

<style scoped></style>
